import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'
import { TgtLogger } from '@measurement/opentelemetry-web'

export const IndirectItemReports = () => {
  return (
    <MicroFrontEnd
      name="IndirectItemReports"
      src={apiConfig.microFrontEnds.IndirectItemReports}
      useErrorBoundary
      logger={TgtLogger}
    />
  )
}
export default IndirectItemReports
